import { get, patch } from '@/api/base'

const usersApi = {
  getCurrent: async () => {
    const response = await get({ path: 'user' })
    return response.success ? response.data.user : null
  },
  update: async params => {
    const response = await patch({ path: 'user', params: { ...params } })
    return response.success ? { ...response, user: response.data } : response
  },
}

export default usersApi
